const ABProcessTaskUserCore = require("../../../core/process/tasks/ABProcessTaskUserCore");
module.exports = class ABProcessTaskUser extends ABProcessTaskUserCore {};
